"use strict"; // https://infra.spec.whatwg.org/#namespaces

exports.HTML_NS = "http://www.w3.org/1999/xhtml";
exports.MATHML_NS = "http://www.w3.org/1998/Math/MathML";
exports.SVG_NS = "http://www.w3.org/2000/svg";
exports.XLINK_NS = "http://www.w3.org/1999/xlink";
exports.XML_NS = "http://www.w3.org/XML/1998/namespace";
exports.XMLNS_NS = "http://www.w3.org/2000/xmlns/";